import CircleProgress from "@/components/CircleProgress.vue";

export default CircleProgress;
